module.exports = __webpack_public_path__ + "829d0bd52cd012a160d9c8c0e3576e02.svg";